const useHasPermission = ({ permissionName }) => {
  const userDetails = JSON.parse(sessionStorage.getItem("loggedUserData"));
  const allPermission =
    userDetails?.user_data?.role_permission?.portal_permission_id;
  const hasPermission = allPermission?.[permissionName];
  return hasPermission;
};

export default useHasPermission;
